var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogoDance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#29006C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55322 51.9533C14.1594 45.3331 21.8236 41 30.4998 41C38.9253 41 46.3965 45.0863 51.0395 51.3853C45.6248 56.713 38.1962 60 29.9998 60C22.0988 60 14.9111 56.9456 9.55322 51.9533Z",
    fill: "#C071FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3041 21.7996L36.5254 19.6797C37.9157 18.3529 37.9157 16.1975 36.5254 14.8707L31.7845 19.3951V16.4009C31.7845 14.52 30.1864 13 28.2208 13V19.3951L25.9995 17.2752C24.6092 15.9484 22.3506 15.9484 20.9603 17.2752L25.7012 21.7996H22.5637C20.5927 21.7996 19 23.3246 19 25.2004H25.6959L23.4746 27.3203C22.0843 28.6471 22.0843 30.8025 23.4746 32.1293L28.2155 27.6049V30.5991C28.2155 32.48 29.8136 34 31.7792 34V27.6049L34.0005 29.7248C35.3908 31.0516 37.6494 31.0516 39.0397 29.7248L34.2988 25.2004H37.4363C39.4073 25.2004 41 23.6754 41 21.7996H34.3041Z",
    fill: "#C071FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoDance);
export default __webpack_public_path__ + "static/media/user-logo-dance.9db834bc50bebfb4a8caef8ca483362e.svg";
export { ForwardRef as ReactComponent };